import React from "react";
// import { Search } from "react-feather"; // Commented to avoid error
import {
  Card,
  CardBody,
  Row,
  Col,
  Table,
  Input,
  Button,
  Pagination,
  PaginationItem,
  PaginationLink
} from "reactstrap";

const Recollections = () => {
  return (
    <div className="p-3">
      <h5 className="mb-4">Recollections</h5>

      {/* Search Bar */}
      <Row className="mb-3 align-items-center">
        <Col md="4">
          <Input type="text" placeholder="Search" />
        </Col>
        <Col md="2">
          <Button color="primary" block>
            {/* <Search size={16} className="me-1" /> */}
            Search
          </Button>
        </Col>
      </Row>

      {/* Table */}
      <Card>
        <CardBody>
          <div className="table-responsive">
            <Table striped hover>
              <thead>
                <tr>
                  <th>Action</th>
                  <th>Description</th>
                  <th>Created</th>
                  <th>Assigned To</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <strong>Reconcile unmatched eRA item</strong>
                  </td>
                  <td>
                    <strong>
                      JR ANTHONYRAJAH’S (563540790) visit on 05/08/2024
                    </strong>
                  </td>
                  <td>21/08/2024</td>
                  <td>0534307_2</td>
                </tr>
                <tr>
                  <td>Acknowledge eRA processed</td>
                  <td>Discovery eRA processed</td>
                  <td>14/08/2024</td>
                  <td>0534307_2</td>
                </tr>
                <tr>
                  <td>Reconcile unmatched eRA item</td>
                  <td>
                    RN MIDNAMDE’S (62987440) visit on 20/08/2024
                  </td>
                  <td>28/08/2024</td>
                  <td>-</td>
                </tr>
                {/* More rows here */}
              </tbody>
            </Table>
          </div>

          {/* Pagination */}
          <div className="d-flex justify-content-between align-items-center mt-3">
            <div>Showing 1 to 10 of 12 entries</div>
            <Pagination className="mb-0">
              <PaginationItem disabled>
                <PaginationLink previous />
              </PaginationItem>
              <PaginationItem active>
                <PaginationLink>1</PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink>2</PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink>3</PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink next />
              </PaginationItem>
            </Pagination>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default Recollections;
